import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/layout/Header";
import Navbar from "../components/layout/Navbar";
import Main from "../containers/Main";
import Nav from "../components/layout/Nav";

const Dashboard = ({children}) => {


  return (
    // <html lang="en">
    //     <body style={{ backgroundColor: "#FAFBFF" }}>
          <main className="h-screen overflow-hidden w-full">
          
              <div className="h-full flex ">
                <Nav>
                  <Outlet/>
                </Nav>
              </div>
           
          </main>
      //   </body>
      // </html>
  )

  return (
    <>
      <div className={`flex flex-col h-screen bg-gray-100  overflow-hidden`}>
        <div className={`flex h-full bg-gray-100 flex-1 overflow-x-hidden`}>
          <Navbar />
          <div className="flex flex-col flex-1">
            <Header />
            <Main>
              <Outlet />
            </Main>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className="flex h-screen overflow-hidden">
      <Navbar />
      <div className="flex flex-col flex-1">
        <Header />
        <main className="flex-1 bg-gray-100 p-4 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
